import { useState, useEffect } from "react";
import bgHero from "../assets/images/bg-hero.png";
import icon4 from "../assets/images/icon4.png";
import icon2 from "../assets/images/icon2.png";
import icon3 from "../assets/images/icon3.png";
import { sendContactEmail } from "../services/emailService";

const interestOptions = [
  "IT Services",
  "Web design",
  "App Dev",
  "Computer Repair",
  "AI Agents",
  "Other",
];

const Hero = () => {
  const [selectedInterest, setSelectedInterest] = useState("IT Services");
  const [showGlow, setShowGlow] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // null, 'success', 'error'

  const handleFormGlow = () => {
    setShowGlow(true);
    setTimeout(() => setShowGlow(false), 3000);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const result = await sendContactEmail({
        ...formData,
        interest: selectedInterest
      });

      if (result.success) {
        setSubmitStatus('success');
        setFormData({ name: "", email: "", message: "" });
        setSelectedInterest("IT Services");
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    window.handleFormGlow = handleFormGlow;
    return () => {
      delete window.handleFormGlow;
    };
  }, []);

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] flex items-center justify-center bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: `url(${bgHero})` }}
    >
      <div className="flex flex-col lg:flex-row gap-8 w-full mx-auto px-8 py-12 items-center justify-between max-w-[1250px]">
        {/* Left Content */}
        <div className="flex-1 flex flex-col justify-between max-w-xl h-full min-h-[520px]">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 !leading-[70px]">
              AI + IT Solutions,
              <br />
              Made Simple.
            </h1>
            <p className="font-semibold text-lg text-gray-800 mb-4">
              HubReady IT keeps your business running smoothly by:
            </p>
            <ul className="space-y-3 text-lg mb-12">
              <li className="flex items-start gap-2">
                <img src={icon4} alt="check" className="w-6 h-6 mt-1" />
                Securing your data and network
              </li>
              <li className="flex items-start gap-2">
                <img src={icon4} alt="check" className="w-6 h-6 mt-1" />
                Backing up your files
              </li>
              <li className="flex items-start gap-2">
                <img src={icon4} alt="check" className="w-6 h-6 mt-1" />
                Providing reliable Helpdesk support
              </li>
              <li className="flex items-start gap-2">
                <img src={icon4} alt="check" className="w-6 h-6 mt-1" />
                Implement AI Agents to help staff
              </li>
            </ul>
          </div>
          <div className="flex flex-col justify-between lg:justify-start sm:flex-row gap-6 mt-8 md:mt-0">
            {/* Avg. response time */}
            <div className="bg-blue-50 rounded-xl px-6 py-4 flex flex-col items-start gap-4 shadow-md max-w-[180px]">
              <div className="text-sm text-gray-600 font-bold">
                Avg. response time
              </div>
              <div className="flex items-center gap-2">
                <img src={icon2} alt="response" className="w-10 h-10" />
                <div>
                  <div className="text-xl font-bold text-gray-900">28 sec.</div>
                </div>
              </div>
            </div>
            {/* Avg. resolve time */}
            <div className="bg-blue-50 rounded-xl px-6 py-4 flex flex-col items-start gap-4 shadow-md max-w-[180px]">
              <div className="text-sm text-gray-600 font-bold">
                Avg. resolve time
              </div>
              <div className="flex items-center gap-2">
                <img src={icon3} alt="response" className="w-9 h-10" />
                <div>
                  <div className="text-xl font-bold text-gray-900">
                    17.5 min.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Right Form */}
        <form
          id="consultation-form"
          onSubmit={handleSubmit}
          className={`flex-1 max-w-sm w-full bg-white rounded-2xl shadow-lg p-8 mt-12 md:mt-0 transition-all duration-700 ${
            showGlow
              ? "shadow-2xl ring-4 ring-blue-600 ring-opacity-70 animate-pulse shadow-blue-500/50"
              : ""
          }`}
          style={{
            boxShadow: showGlow
              ? "0 0 30px rgba(37, 99, 235, 0.6), 0 0 60px rgba(37, 99, 235, 0.3)"
              : undefined,
          }}
        >
          <h2 className="text-xl font-semibold text-blue-500 text-center mb-6">
            FREE CONSULTATION
          </h2>
          {showGlow && (
            <div className="text-center mb-4">
              <p className="text-blue-600 font-semibold text-sm animate-pulse">
                ✨ To contact us, please fill out this form ✨
              </p>
            </div>
          )}
          <div className="mb-4">
            <div className="text-gray-700 mb-2">I'm interested in:</div>
            <div className="flex flex-wrap gap-2 mb-4">
              {interestOptions.map((option) => (
                <button
                  key={option}
                  type="button"
                  className={`px-3 py-1 rounded-full text-sm font-semibold focus:outline-none transition-all ${
                    selectedInterest === option
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 text-gray-700"
                  }`}
                  onClick={() => setSelectedInterest(option)}
                >
                  {option}
                </button>
              ))}
            </div>
            <label htmlFor="name" className="block text-gray-700 mb-2">
              Your Name*
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Jhon Smith"
              className="w-full border-b border-gray-200 py-1 mb-4 outline-none text-gray-700 placeholder-gray-300 text-base focus:border-blue-300 transition"
              required
            />
            <label htmlFor="name" className="block text-gray-700 mb-2">
              Your email*
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="email@gmail.com"
              className="w-full border-b border-gray-200 py-1 mb-4 outline-none text-gray-700 placeholder-gray-300 text-base focus:border-blue-300 transition"
              required
            />
            <label htmlFor="name" className="block text-gray-700 mb-2">
              Your message*
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Your message:"
              className="w-full border border-gray-200 rounded-lg py-2 px-3 h-20 resize-none outline-none text-gray-700 placeholder-gray-300 mb-6 text-base focus:border-blue-300 transition"
              required
            ></textarea>
            {/* Status Messages */}
            {submitStatus === 'success' && (
              <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-lg text-sm">
                ✅ Thank you! Your message has been sent successfully. We'll get back to you soon.
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">
                ❌ Sorry, there was an error sending your message. Please try again or contact us directly.
              </div>
            )}
            
            <button 
              type="submit"
              disabled={isSubmitting}
              className={`w-full py-3 rounded-full font-bold text-lg mt-2 transition ${
                isSubmitting 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-blue-500 hover:bg-blue-600'
              } text-white`}
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Sending...
                </span>
              ) : (
                <>Submit Ticket <span className="ml-2">&gt;</span></>
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Hero;
